/**
 * Health Badge Component
 *
 * Displays a health score with color-coded indicator.
 * Green (80%+), Yellow (60-79%), Red (<60%)
 */

const healthConfig = {
  healthy: {
    bg: 'bg-green-100',
    text: 'text-green-800',
    border: 'border-green-200',
    label: 'Healthy',
  },
  needs_attention: {
    bg: 'bg-yellow-100',
    text: 'text-yellow-800',
    border: 'border-yellow-200',
    label: 'Needs Attention',
  },
  at_risk: {
    bg: 'bg-red-100',
    text: 'text-red-800',
    border: 'border-red-200',
    label: 'At Risk',
  },
};

function getHealthLevel(score) {
  if (score === null || score === undefined) return null;
  if (score >= 80) return 'healthy';
  if (score >= 60) return 'needs_attention';
  return 'at_risk';
}

export default function HealthBadge({ score, showLabel = true, size = 'sm' }) {
  const level = getHealthLevel(score);

  if (!level) {
    return (
      <span className="px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-500 border border-gray-200">
        N/A
      </span>
    );
  }

  const config = healthConfig[level];
  const sizeClasses = size === 'lg' ? 'px-3 py-1.5 text-sm' : 'px-2 py-1 text-xs';

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-medium border ${sizeClasses} ${config.bg} ${config.text} ${config.border}`}
    >
      {score !== null && <span>{score}%</span>}
      {showLabel && <span>- {config.label}</span>}
    </span>
  );
}
